"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var tslib_1 = require("tslib");

var ui_field_error_message_1 = require("@hopin-team/ui-field-error-message");

var ui_field_helper_message_1 = require("@hopin-team/ui-field-helper-message");

var ui_field_label_1 = require("@hopin-team/ui-field-label");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_hooks_1 = require("@hopin-team/ui-helper-hooks");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_menu_1 = require("@hopin-team/ui-menu");

var ui_visually_hidden_1 = require("@hopin-team/ui-visually-hidden");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importStar(require("react"));

var custom_input_1 = require("./partials/custom-input");

var custom_select_1 = require("./styled/custom-select");

var native_select_1 = require("./styled/native-select");

var options_1 = require("./styled/options");

var root_1 = require("./styled/root");

var isOptionDisabledBuiltIn = function isOptionDisabledBuiltIn(option) {
  return Boolean(option.disabled);
};

var Select = function Select(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      className = _a.className,
      disabled = _a.disabled,
      errorMessage = _a.errorMessage,
      hasErrors = _a.hasErrors,
      helperText = _a.helperText,
      _b = _a.hideOptionsLabel,
      hideOptionsLabel = _b === void 0 ? 'Hide options' : _b,
      hideLabel = _a.hideLabel,
      id = _a.id,
      isRequired = _a.isRequired,
      label = _a.label,
      leadingIcon = _a.leadingIcon,
      options = _a.options,
      placeholder = _a.placeholder,
      _c = _a.requiredText,
      requiredText = _c === void 0 ? 'required' : _c,
      setValue = _a.setValue,
      _d = _a.showOptionsLabel,
      showOptionsLabel = _d === void 0 ? 'Show options' : _d,
      _e = _a.size,
      size = _e === void 0 ? 'medium' : _e,
      trailingIcon = _a.trailingIcon,
      value = _a.value,
      visibleOptionsCount = _a.visibleOptionsCount,
      _f = _a.isOptionDisabled,
      isOptionDisabled = _f === void 0 ? isOptionDisabledBuiltIn : _f;

  var _g = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Select',
    className: className,
    __UIScope: __UIScope
  }),
      makeClasses = _g.makeClasses,
      rootClasses = _g.rootClasses;

  var _id = (0, use_id_1.useId)(id);

  var nativeSelectId = "native--".concat(_id);
  var customSelectId = "custom--".concat(_id);
  var menuSelectId = "menu--".concat(_id);
  var errorMsgId = "error-msg-".concat(_id);
  var helperMsgId = "helper-msg-".concat(_id);
  var a11yProps = {};

  if (hasErrors && errorMessage) {
    a11yProps['aria-describedby'] = errorMsgId;
  }

  if (!hasErrors && helperText) {
    a11yProps['aria-describedby'] = helperMsgId;
  }

  var validVisibleOptions = visibleOptionsCount && options.length > visibleOptionsCount ? visibleOptionsCount : undefined;
  /**
   * Native Select
   * Touch devices should render a native select element.
   */

  var onChange = function onChange(e) {
    return setValue(e.target.value);
  };
  /**
   * Custom Select
   * Devices with a mouse will render a custom select.
   */


  var _h = tslib_1.__read((0, react_1.useState)(false), 2),
      isCustomSelectShowing = _h[0],
      setIsCustomSelectShowing = _h[1];

  var _j = tslib_1.__read((0, react_1.useState)(false), 2),
      isCustomSelectFocused = _j[0],
      setIsCustomSelectFocused = _j[1];

  var onShowCustomSelect = function onShowCustomSelect() {
    return setIsCustomSelectShowing(!isCustomSelectShowing);
  };

  var onCloseCustomSelect = function onCloseCustomSelect() {
    setIsCustomSelectShowing(false);
    setIsCustomSelectFocused(false);
  };

  var onItemClick = function onItemClick(value) {
    setValue(value);
    onCloseCustomSelect();
  };

  var onLabelClick = function onLabelClick() {
    return setIsCustomSelectFocused(true);
  };

  var isInFocus = isCustomSelectShowing || isCustomSelectFocused;
  var currentSelectionIndex = options.findIndex(function (option) {
    return option.value === value;
  });
  var currentIndex = currentSelectionIndex >= 0 ? currentSelectionIndex : 0;
  var currentSelection = currentSelectionIndex >= 0 ? options[currentSelectionIndex] : {
    label: '',
    value: ''
  };
  var rootRef = (0, react_1.useRef)(null);
  (0, ui_helper_hooks_1.useOnClickOutside)(rootRef, onCloseCustomSelect);
  (0, ui_helper_hooks_1.useOnKeyPress)('Escape', onCloseCustomSelect);

  var _k = (0, ui_helper_hooks_1.useDeviceDetection)(),
      isTouchDevice = _k.isTouchDevice,
      isDesktop = _k.isDesktop;

  var getOptionLabelText = function getOptionLabelText(label) {
    return typeof label === 'string' ? label : label.text;
  };

  var Label = function Label() {
    return react_1.default.createElement(ui_field_label_1.FieldLabel, {
      className: makeClasses('Label'),
      fieldId: isTouchDevice ? nativeSelectId : menuSelectId,
      id: customSelectId,
      isDisabled: disabled,
      isRequired: isRequired,
      label: label,
      onClick: onLabelClick,
      requiredText: requiredText,
      mb: 0.5
    });
  };

  return react_1.default.createElement(root_1.Root, {
    className: rootClasses,
    "data-testid": testID,
    ref: rootRef
  }, hideLabel ? react_1.default.createElement(ui_visually_hidden_1.VisuallyHidden, {
    as: "div"
  }, react_1.default.createElement(Label, null)) : react_1.default.createElement(Label, null), isTouchDevice && react_1.default.createElement(native_select_1.NativeSelect, tslib_1.__assign({
    className: makeClasses('NativeSelect'),
    id: nativeSelectId,
    onChange: onChange,
    disabled: disabled,
    required: isRequired,
    sizeOption: size,
    value: value || placeholder
  }, a11yProps), placeholder && react_1.default.createElement("option", {
    value: ""
  }, placeholder), options.map(function (option, i) {
    return react_1.default.createElement("option", {
      key: i,
      value: option.value,
      disabled: isOptionDisabled(option)
    }, getOptionLabelText(option.label));
  })), isDesktop && react_1.default.createElement(ui_menu_1.Menu, {
    isShowing: isCustomSelectShowing
  }, react_1.default.createElement(custom_select_1.CustomSelect, tslib_1.__assign({
    className: makeClasses('CustomSelect')
  }, a11yProps), react_1.default.createElement(custom_input_1.CustomInput, {
    className: makeClasses('CustomInput'),
    id: menuSelectId,
    disabled: disabled,
    inFocus: isInFocus,
    hasErrors: hasErrors,
    onClick: onShowCustomSelect,
    placeholder: placeholder,
    sizeOption: size,
    currentLabel: getOptionLabelText(currentSelection.label),
    leadingIcon: leadingIcon,
    trailingIcon: trailingIcon,
    ariaLabel: isCustomSelectShowing ? hideOptionsLabel : showOptionsLabel,
    ariaExpanded: isCustomSelectShowing
  }), react_1.default.createElement(options_1.Options, {
    visibleOptionsCount: validVisibleOptions
  }, react_1.default.createElement(ui_menu_1.MenuSelect, {
    labelledById: menuSelectId,
    role: "listbox",
    m: 1,
    currentIndex: currentIndex
  }, options.map(function (option, i) {
    return react_1.default.createElement(ui_menu_1.MenuSelectItem, {
      disabled: isOptionDisabled(option),
      key: i,
      label: getOptionLabelText(option.label),
      subtext: typeof option.label === 'string' ? undefined : {
        label: option.label.subtext,
        position: 'bottom'
      },
      role: "option",
      "aria-selected": option.value === value,
      p: 1,
      my: 1,
      onClick: function onClick() {
        return onItemClick(option.value);
      },
      leadingIcon: option.leadingIcon,
      trailingIcon: option.trailingIcon
    });
  }))))), hasErrors && errorMessage && react_1.default.createElement(ui_field_error_message_1.FieldErrorMessage, {
    className: makeClasses('ErrorMessage'),
    mt: 1,
    errorMessage: errorMessage,
    id: errorMsgId
  }), !hasErrors && helperText && react_1.default.createElement(ui_field_helper_message_1.FieldHelperMessage, {
    helperMessage: helperText,
    mt: 1,
    className: makeClasses('HelperMessage'),
    id: helperMsgId
  }));
};

var SelectWithSpace = (0, ui_helper_with_space_1.withSpace)(Select);
exports.Select = SelectWithSpace;